const social = {
  github: "https://github.com/PrajjvalMehra",
  linkedIn: "https://www.linkedin.com/in/prajjval-mehra/",
  email: "prajjvalmehra09@gmail.com",
  instagram: "https://www.instagram.com/inferiorconjunction/",
};

export { social };
